import styles from "@components/ClientVisibleTaskResources.module.css";
import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import useSanitizeHtml from "@hooks/useSanitizeHtml";
import { ResourceFeatureKindEnum, ResourceFragment, TaskFragment } from "@typing/Generated";

type Props = {
  chartValueWrapperStyles: (r: ResourceFragment) => string;
  index: number;
  journeyId: string;
  resource: TaskFragment["resources"][number];
  resourceFeature: TaskFragment["resourceFeatures"][number];
};

const ClientVisibleTaskResource = ({ chartValueWrapperStyles, index, journeyId, resource, resourceFeature }: Props) => {
  const featureValue = resource.featureValues.find(fv => fv.resourceFeature.id === resourceFeature.id);

  const sanitizedBody = useSanitizeHtml({ journeyId, rawHtml: featureValue?.textValue, resource });

  if (resourceFeature.kind === ResourceFeatureKindEnum.BOOLEAN) {
    if (featureValue?.booleanValue === true) {
      return (
        <div
          className={`${styles.chartColumn} ${index % 2 === 1 ? styles.chartColumnOdd : styles.chartColumnEven}`}
          key={resource.id}
        >
          <div className={chartValueWrapperStyles(resource)}>
            <div>
              <BodyCopy color="gray-500" size="small">
                {resourceFeature.name}
              </BodyCopy>
              <div className="margin-4-top">
                <div className={styles.chartValueYes}>
                  <Icon color="white" icon="checkmark" size="small" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (featureValue?.booleanValue === false) {
      return (
        <div className={`${styles.chartColumn}`} key={resource.id}>
          <div className={chartValueWrapperStyles(resource)}>
            <div>
              <div>
                <BodyCopy color="gray-500" size="small">
                  {resourceFeature.name}
                </BodyCopy>
              </div>
              <div className="margin-4-top">
                <div className={styles.chartValueNo}>
                  <Icon color="white" icon="xmark" size="small" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={`${styles.chartColumn}`} key={resource.id}>
          <div className={chartValueWrapperStyles(resource)}></div>
        </div>
      );
    }
  } else {
    return (
      <div className={`${styles.chartColumn}`} key={resource.id}>
        <div className={chartValueWrapperStyles(resource)}>
          <div>
            <BodyCopy color="gray-500" size="small">
              {resourceFeature.name}
            </BodyCopy>
            <div className="margin-4-top">
              <BodyCopy color="gray">{sanitizedBody}</BodyCopy>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ClientVisibleTaskResource;
